<template>
  <div v-if="display">
    <modal-layout-top :title="title" :subTitle="customerName" />
    <div class="content slider-modal">
      <div class="slider-modal-fields">
        <template v-if="displayCustomerSelect">
          <div class="slider-subtitle">Kund</div>
          <div class="field">
            <label class="label">Kund</label>
            <div class="is-flex">
              <model-list-select
                class="is-inline-input"
                :list="customers"
                option-value="customerId"
                option-text="name"
                v-model="license.customerId"
                placeholder="Välj kund...">
              </model-list-select>
            </div>
            <!-- <div v-show="errors.has('customerId')" class="invalid-feedback">{{ errors.first('customerId') }}</div> -->
          </div>
        </template>

        <div class="slider-subtitle">Licens</div>

        <div class="field">
          <label class="label">Produkt</label>
          <div class="select">
            <select v-model="license.product">
              <option :value="null">Välj produkt...</option>
              <option value="InteractiveBowling">Interactive Bowling</option>
              <option value="InteractivePanel">Interactive Panel</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">CPU-ID</label>
          <input class="input" v-model="license.cpuId" />
        </div>

        <div class="field">
          <label class="label">Slutdatum</label>
          <input class="input" type="date" v-model="license.licenseEndDate" />
        </div>

        <div class="field">
          <label class="label">Aktiv</label>
          <input id="license-active" type="checkbox" v-model="license.active" class="switch is-rounded active-switch">
          <label for="license-active" class="label active-switch">Aktiv</label>
        </div>

        <div class="field-full">
          <label class="label">Licensnyckel</label>
          <div class="is-flex">
            <div class="is-inline-input">
              <input class="input" v-model="license.licenseKey" readonly />
            </div>
            <button @click="generateLicenseKey()" class="button is-inline-button is-info"><i class="fal fa-refresh"></i></button>
          </div>
        </div>

        <div class="slider-subtitle">Installation</div>

        <div class="field-full">
          <label class="label">Version</label>
          <input class="input" v-model="license.softwareVersion" />
        </div>

        <div class="field">
          <label class="label">Installerat datum</label>
          <input class="input" type="date" v-model="license.installationDate" />
        </div>

        <div class="field">
          <label class="label">Installerat av</label>
          <div class="select">
            <select v-model="license.installedByUserId">
              <option :value="null">Välj installatör...</option>
              <option v-for="user in staffUsers" :value="user.userId" :key="user.userId">{{ user.fullName }}</option>
            </select>
          </div>
        </div>

        <div class="slider-subtitle">Kommentar</div>
        <div class="field-full">
          <textarea class="textarea" v-model="license.comments" />
        </div>

        <div class="slider-subtitle">Senaste kontroll</div>
        <div class="field-full">
          <div class="mini-table-wrapper">
            <div class="key">Datum</div>
            <div class="value" v-if="license.lastCheckResult">
              <div style="display: flex">
                <template v-if="license.lastCheckResult === 'Ok'">
                  <i class="fal fa-check success-warning-error-icon success"></i>
                </template>
                <template v-else-if="license.lastCheckResult === 'Warning'">
                  <i class="fal fa-exclamation success-warning-error-icon warning"></i>
                </template>
                <template v-else-if="license.lastCheckResult === 'Error'">
                  <i class="fal fa-exclamation success-warning-error-icon error"></i>
                </template>
                <div style="margin-left: 0.5rem">{{ lastCheckDate }}</div>
              </div>
            </div>
            <div v-else><i>Inga anrop har gjorts än</i></div>
          </div>
          <div class="mini-table-wrapper" v-if="license.lastCheckResult === 'Error' || license.lastCheckResult === 'Warning'">
            <div class="key">Meddelande</div>
            <div class="value">{{ messageText }}</div>
          </div>
        </div>

        <div class="slider-subtitle">Övrigt</div>
        <div class="field-full meta-data">Skapad av {{ license.createdByFullName }} {{ license.dateCreated | dateTime }}</div>
        <div class="field-full meta-data" v-if="license.modifiedByUserId">Senast ändrad av {{ license.modifiedByFullName }} {{ license.dateModified | dateTime }}</div>

      </div>

      <modal-layout-buttons :store-name="'licenses'" />
    </div>
  </div>

</template>

<script>
import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import { ModelListSelect } from 'vue-search-select'
import { getProductName } from '@/helpers'

export default {
  name: 'license-modal',
  computed: {
    title: function () {
      if (this.licenseId) {
        return 'Redigera licens ' + getProductName(this.license.product)
      }
      else {
        return 'Lägg till ny licens'
      }
    },

    customerName: function () {
      if (this.license.licenseId) {
        return this.license.customerName
      }
      else if (this.customer) {
        return this.customer.name
      }

      return null
    },

    lastCheckDate () {
      if (!this.license.lastCheckDate) {
        return '-'
      }

      return this.$options.filters.dateTime(this.license.lastCheckDate)
    },

    messageText () {
      switch (this.license.lastCheckErrorCode) {
        case 'LicenseKeyExpired': return 'Licensnyckelns slutdatum har passerat'
        case 'LicenseKeyAboutToExpire': return 'Licensnyckelns slutdatum närmar sig'
        case 'InvalidCpuId': return 'Fel CPU-ID'
        case 'LicenseInactivated': return 'Licensnyckel inaktiverad'
        default: return 'Okänt fel'
      }
    }
  },

  data () {
    return {
      license: {
        customerId: null,
        product: null,
        endDate: null,
        licenseKey: null
      },
      customers: [],
      displayCustomerSelect: true,
      display: false,
      customer: null,
      staffUsers: null
    }
  },

  components: {
    ModalLayoutTop,
    ModalLayoutButtons,
    ModelListSelect
  },

  props: {
    licenseId: {
      type: Number,
      required: false
    },

    customerId: {
      type: Number,
      required: false,
      default: 0
    }
  },

  methods: {
    ...mapActions({
      getLicenseById: 'licenses/getById',
      create: 'licenses/create',
      update: 'licenses/update',
      getAllCustomers: 'customers/getAll',
      getCustomerById: 'customers/getById',
      getUsersInRole: 'users/getAllInRole'
    }),

    generateLicenseKey () {
      if (this.license.licenseKey) {
        this.$confirm('Generera ny licensnyckel?', 'Är du säker?').then(result => {
          if (result.value) {
            this.license.licenseKey = this.$uuid.v4()
          }
        })
      }
      else {
        this.license.licenseKey = this.$uuid.v4()
      }
    },

    closePanel () {
      this.$emit('closePanel', { response: this.license })
    },

    validateFields () {
      const errors = []

      if (!this.license.customerId) {
        errors.push('Välj kund')
      }

      if (!this.license.product) {
        errors.push('Välj produkt')
      }

      if (!this.license.licenseEndDate) {
        errors.push('Välj slutdatum')
      }

      if (errors.length) {
        this.$toast(errors.join('\n'), 'error')
        return false
      }

      return true
    },

    save () {
      this.submitted = true

      if (!this.validateFields()) {
        return
      }

      if (this.licenseId) {
        this.update(this.license).then(response => {
          this.closePanel()
        })
      } else {
        this.create(this.license).then(license => {
          this.license = license
          this.closePanel()
        })
      }
    }
  },

  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    let promises = []

    promises.push(this.getAllCustomers().then(customers => {
      this.customers = customers
    }))

    if (this.licenseId) {
      promises.push(this.getLicenseById(this.licenseId).then(license => {
        this.license = license.result
        this.displayCustomerSelect = !this.license.customerId
      }))
    }
    else {
      this.generateLicenseKey()
    }

    if (this.customerId) {
      this.license.customerId = this.customerId

      promises.push(this.getCustomerById(this.customerId).then(customer => {
        this.customer = customer.result
        this.displayCustomerSelect = !this.customer.customerId
      }))
    }

    promises.push(this.getUsersInRole('Staff').then(staffUsers => {
      this.staffUsers = staffUsers
    }))

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>

<style lang="scss" scoped>
  .is-inline-input {
    flex-grow: 1;
  }

  .is-inline-button {
    text-align: right;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/LicenseModal.vue